<script>
import { defineComponent, onMounted, getCurrentInstance, watch } from 'vue';
import msCombobox from './MsCombobox.vue';
import { useValidateControl } from '@/setup/validateControl.js';
import { MSConstant } from '@/commons/wildcards';
import i18nGlobal from '@/i18ns/i18n';
const i18n = i18nGlobal.global;
import commonFn from '@/commons/commonFunction';

export default defineComponent({
  name: 'msComboboxEnum',
  extends: msCombobox,
  props: {
    enum: {
      default: null,
      type: String,
    },
    /**
     * @override
     */
    valueField: {
      type: String,
      default: 'enumValue',
    },
    /**
     * @override
     */
    displayField: {
      type: String,
      default: 'enumText',
    },

    values: {
      type: [Array, String],
      default: '',
    },

    /**
     * Custom dữ liệu
     */
    customData: {
      default: null,
      type: [Array, Function],
    },
  },

  setup(props) {
    //Variable
    const { proxy } = getCurrentInstance();

    const { errorMessage, handlerValidateCombobox, getTitleError } =
      useValidateControl({
        props,
      });
    const validate = () => {
      return handlerValidateCombobox();
    };
    //Hooks
    onMounted(() => {
      loadEnumSource();

      //init start value
      proxy.internalValue = props.modelValue;
      updateDiplayText(proxy.internalValue);
    });

    //Method
    /**
     * Bổ sung values theo dạng text hoặc mảng để có thể filter theo enum
     * NCPHUOC 15/07/2022
     */
    const loadEnumSource = () => {
      let source = proxy.$ms.commonFn.getEnumSource(proxy.enum, proxy.values);
      if (Array.isArray(source)) {
        let filterItems = [];
        if (Array.isArray(props.values) && props.values.length > 0) {
          filterItems = props.values;
        } else {
          if (props.values) {
            filterItems = props.values.split(',');
          }
        }

        if (filterItems.length > 0) {
          const map = new Map();
          //Map lại để lấy cho nhanh
          filterItems.forEach((x) => {
            map.set(x, 1);
          });
          source = source.filter((item) => map.has(item.enumValue));
        }
      }

      /** Xử lý custom dữ liệu */
      if (proxy.customData) {
        if (Array.isArray(proxy.customData)) {
          source = proxy.customData.concat(source);
        }

        if (typeof proxy.customData == 'function') {
          source = proxy.customData(source);
        }
      }

      proxy._allData = source;
    };

    /**
     * Override lại hàm này, thêm set internal value trên comboboxenum
     */
    const setInitText = (val) => {
      proxy.internalText = proxy.initText ? proxy.initText : val;
      const sources = MSConstant[props.enum];
      if (Object.keys(sources)?.length > 0) {
        let value = null;
        for (const key in sources) {
          let enumText = i18n.t('i18nEnum.' + props.enum + '.' + key);
          if (val === enumText) {
            value = sources[key];
            break;
          }
        }

        if (typeof value !== 'undefined' && value !== null) {
          proxy.setValue(value);
        }
      }
    };

    watch(
      () => props.modelValue,
      (value, oldValue) => {
        updateDiplayText(value);
      }
    );

    /**
     * Cập nhật text hiển thị theo enum value
     */
    const updateDiplayText = (value) => {
      let text = commonFn.getEnumResource(value, props.enum) || '';
      proxy.setInitText(text);
    }

    return {
      validate,
      errorMessage,
      getTitleError,
      setInitText,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsCombobox.scss';
</style>
